<template>
  <div>
    <transition name="fade" appear>
      <component-data
        v-if="paymentMethod == 'payland'"
        class="mt-10"
        title="Metodos de pago"
      >
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="radio-input mt-5"
        >
          <div class="flex">
            <input
              type="radio"
              :id="'card-' + index"
              :value="card.uuid"
              v-model="selectedCard"
              class="mt-2"
            />
            <label :for="'card-' + index" class="w-full pl-3">
              <div class="payments-container__label">
                <div class="flex flex-col pl-6">
                  <span>{{ card.holder }}</span>
                  <span>{{ card.brand }}</span>
                  <span
                    >{{ translations.card_number[lang] }}: **** **** ****{{
                      card.last4
                    }}</span
                  >
                  <span
                    >{{ translations.expiry[lang] }}: {{ card.expire_month }}/{{
                      card.expire_year
                    }}</span
                  >
                </div>
              </div>
            </label>
          </div>
        </div>
      </component-data>
    </transition>

    <!-- <div v-show="showForm" id="paylands-content">
      <iframe
        class=""
        :src="url"
        width="100%"
        height="100%"
        frameborder="0"
      ></iframe>
    </div> -->
  </div>
</template>

<script>
import {
  GET_PAYLANDS_PARAMS,
  STORE_ORDER_ACTION,
  GET_PAYMENT_METHOD,
  GET_CARDS,
  GET_SELECTED_CARD_UUID,
  SET_SELECTED_CARD_UUID,
} from "../../../store/wizard/types";
import { mapGetters, mapActions } from "vuex";
import mixin from "../../../mixin";

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters({
      params: GET_PAYLANDS_PARAMS,
      paymentMethod: GET_PAYMENT_METHOD,
      cards: GET_CARDS,
    }),
    selectedCard: {
      get() {
        return this.$store.getters[GET_SELECTED_CARD_UUID];
      },
      set(value) {
        this.$store.commit(SET_SELECTED_CARD_UUID, value);
      },
    },
  },
  data: () => {
    return {
      showForm: false,
      url: "",
      translations: trans
    };
  },
  methods: {
    ...mapActions({
      storeOrderAction: STORE_ORDER_ACTION,
    }),
    directpayment() {},
  },
  // watch: {
  //   params: function (value) {
  //     this.showForm = true;
  //     console.log(this.params);
  //     this.url =
  //       "https://api.paylands.com/v1/sandbox/payment/process/" +
  //       this.params.order.token;
  //   },
  // },

};
</script>

<style lang="scss">
#paylands-content {
  z-index: 30000;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
